import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Phone } from "lucide-react";
import { SERVICES, COMPANY, IMAGES } from "../data/site";
import { Reveal, Overline, PageHeader } from "../components/Reveal";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader
        overline="Nos services"
        title="Climatisation, pompe à chaleur, chauffage & ventilation"
        subtitle="De l'étude à la mise en service, nous installons, dépannons et entretenons l'ensemble de vos systèmes énergétiques dans le Maine-et-Loire."
      />

      <div className="max-w-7xl mx-auto px-5 md:px-10 py-24 space-y-20">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug}>
            <div
              id={s.slug}
              className={`grid lg:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}
            >
              <div className="[direction:ltr]">
                <div className="w-16 h-16 rounded-2xl bg-navy flex items-center justify-center">
                  <s.icon className="w-8 h-8 text-brand" />
                </div>
                <h2 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight text-navy mt-6">{s.title}</h2>
                <p className="text-text-muted text-lg mt-4 leading-relaxed">{s.desc}</p>
                <ul className="grid sm:grid-cols-2 gap-3 mt-7">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-3 text-navy font-medium">
                      <CheckCircle2 className="w-5 h-5 text-brand shrink-0" /> {p}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/devis"
                  data-testid={`service-quote-${s.slug}`}
                  className="inline-flex items-center gap-2 mt-8 bg-brand hover:bg-brand-dark text-white font-bold py-3.5 px-7 rounded-full transition-colors"
                >
                  Devis pour {s.title.toLowerCase()} <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
              <div className="[direction:ltr]">
                <img
                  src={[IMAGES.acTech, IMAGES.heatpump, IMAGES.chauffage, IMAGES.ventilation][i % 4]}
                  alt={`${s.title} — installation et entretien par MS Énergie à Angers et dans le Maine-et-Loire`}
                  loading="lazy"
                  className="rounded-3xl w-full h-[380px] object-cover shadow-xl border border-border"
                />
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <section className="bg-navy">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
          <div>
            <h3 className="font-display text-2xl md:text-3xl font-extrabold text-white">Un besoin précis ? Parlons-en.</h3>
            <p className="text-white/60 mt-2">Nos techniciens vous conseillent gratuitement.</p>
          </div>
          <a href={`tel:${COMPANY.phoneRaw}`} className="bg-brand text-white font-bold py-4 px-8 rounded-full flex items-center gap-2 hover:bg-brand-dark transition-colors">
            <Phone className="w-5 h-5" /> {COMPANY.phone}
          </a>
        </div>
      </section>
    </div>
  );
}
